import React from 'react';
import { Link } from 'react-router-dom';

const NavigationLink = ({
    to,
    href,
    children,
    className = "main-menu__link btn btn-anim",
    target,
    rel,
    onClick,
    wrapperClassName = "main-menu__item",
    onLinkClick
}) => {
    const handleClick = (e) => {
        // Ejecutar el callback personalizado si existe
        if (onLinkClick) {
            onLinkClick(e);
        }

        // Ejecutar el onClick original si existe
        if (onClick) {
            onClick(e);
        }
    };

    const linkProps = {
        className,
        onClick: handleClick
    };

    // Si hay un href (enlace externo), usar <a>
    if (href) {
        return (
            <li className={wrapperClassName}>
                <a
                    href={href}
                    target={target}
                    rel={rel}
                    {...linkProps}
                >
                    <span className="btn-caption">{children}</span>
                </a>
            </li>
        );
    }

    // Si hay un to (enlace interno), usar Link de React Router
    return (
        <li className={wrapperClassName}>
            <Link
                to={to}
                {...linkProps}
            >
                <span className="btn-caption">{children}</span>
            </Link>
        </li>
    );
};

export default NavigationLink;
